import { Alert, Snackbar } from "@mui/material";
import React from "react";

interface WarningAlertProps {
  show: boolean;
  message: string;
  onDismiss: any;
}

const WarningAlert: React.FC<WarningAlertProps> = ({ show, message, onDismiss }) => {
  return (
    <Snackbar 
      open={show} 
      anchorOrigin={{ vertical: "top", horizontal: "center" }} 
      onClose={onDismiss} 
      autoHideDuration={3000}
      sx={{
        mt: 8,
      }}>
      <Alert onClose={onDismiss} severity="warning" variant="filled" sx={{ width: "100%" }}>
        {message}
      </Alert>
    </Snackbar>
  );
};

export default WarningAlert;
